export default __webpack_public_path__ + "static/media/NFO-login-left.ad2b43f1.jpg";